import { useAuthStore } from "../../store/authStore";
import { api, formatApiErrorDetail } from "../../lib/api";
import { toast } from "sonner";
import { TEST_IDS } from "../../constants/testIds";

const EMOJIS = ["👍", "❤️", "🎉", "🚀", "✅", "👀", "🙌", "🔥"];

export default function CommentReactions({ comment, users, onUpdated }) {
  const { user } = useAuthStore();
  const reactions = comment.reactions || {};
  const userMap = Object.fromEntries(users.map((u) => [u.id, u]));

  const toggle = async (emoji) => {
    try {
      const { data } = await api.post(`/comments/${comment.id}/reactions`, {
        emoji,
      });
      onUpdated(data.reactions);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    }
  };

  return (
    <div className="mt-2 flex flex-wrap items-center gap-1">
      {Object.entries(reactions).map(([emoji, uids]) => {
        const mine = uids.includes(user?.id);
        const names = uids.map((id) => userMap[id]?.name || "?").join(", ");
        return (
          <button
            key={emoji}
            type="button"
            onClick={() => toggle(emoji)}
            title={names}
            data-testid={TEST_IDS.reactionChip(comment.id, emoji)}
            className={[
              "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs transition-colors",
              mine
                ? "border-blue-300 bg-blue-50 text-blue-900"
                : "border-zinc-200 bg-white text-zinc-700 hover:border-zinc-300",
            ].join(" ")}
          >
            <span>{emoji}</span>
            <span className="tabular-nums">{uids.length}</span>
          </button>
        );
      })}
      <div className="relative group">
        <button
          type="button"
          data-testid={TEST_IDS.reactionAddBtn(comment.id)}
          className="rounded-full border border-dashed border-zinc-300 px-2 py-0.5 text-xs text-zinc-500 hover:border-zinc-400 hover:text-zinc-900"
        >
          + 🙂
        </button>
        <div className="absolute left-0 top-6 z-10 hidden gap-1 rounded-md border border-zinc-200 bg-white p-1 shadow-md group-hover:flex group-focus-within:flex">
          {EMOJIS.map((e) => (
            <button
              key={e}
              type="button"
              onClick={() => toggle(e)}
              className="rounded p-1 text-base hover:bg-zinc-100"
              data-testid={TEST_IDS.reactionPick(comment.id, e)}
            >
              {e}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
